$(function(){
    Pace.stop();
    $(".freelancer .previews").lightSlider({
        item: 1,
        pager: false,
        slideMargin: 8,
        prevHtml: '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
        nextHtml: '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
        onSliderLoad: function (el) {
            var src_img = el.find('img').first().attr('data-img');
            var img = new Image();
            img.onload = function () {
                el.find('img').first().attr('src', img.src).fadeIn(100).closest(".lslide").css("background", "transparent");
            };
            img.src = src_img;

        },
        onAfterSlide: function (el) {
            var src_img = el.find('.active img').attr('data-img');
            var img = new Image();
            img.onload = function () {
                el.find('.active img').attr('src', img.src).fadeIn(100).closest(".lslide").css("background", "transparent");
            };
            img.src = src_img;
        }
    });

    var loading = false;
    var $list = $("#list");
    $list.find("#snippet--list").infiniteScroll({
            // options
            path: function(){
                var href = $(".pagination a.nextPage").attr("href");
                return href;
            },
//                    debug: true,
            responseType: 'text',
            scrollThreshold: 400,
            history: false
        }
    ).on( 'load.infiniteScroll', function( event, response, path ) {
        loading = false;
//                console.log("LOAD");
        // hide new items while they are loading
        var data = JSON.parse(response);
        var snippets = data.snippets;
        var $newElems = $(snippets["snippet--list"]).css("opacity", 0);
        // ensure that images load before adding to masonry layout
        $list.find("#snippet--list").append($newElems);

        $("#snippet--paginator").html(snippets["snippet--paginator"]);

        $newElems.fadeIn(0.5, function(){
            Pace.stop();
        });
        $list.masonry( 'appended', $newElems, true );

        $newElems.find(".previews").each(function(){
            var $self = $(this);

            $self.imagesLoaded(function(){
                $self.lightSlider({
                    adaptiveHeight: true,
                    item: 1,
                    pager: false,
                    slideMargin: 8,
                    prevHtml: '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
                    nextHtml: '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
                    onSliderLoad: function (el) {
                        //                        console.log("ONLOAD");
                        var src_img = el.find('img').first().attr('data-img');
                        var img = new Image();
                        img.onload = function () {
                            el.find('img').first().attr('src', img.src).fadeIn(100).closest(".lslide").css("background", "transparent");
                        };
                        img.src = src_img;

                    },
                    onAfterSlide: function (el) {
                        var src_img = el.find('.active img').attr('data-img');
                        var img = new Image();
                        img.onload = function () {
                            el.find('.active img').attr('src', img.src).fadeIn(100).closest(".lslide").css("background", "transparent");
                        };
                        img.src = src_img;
                    }
                });
            });
        });
    }).on( 'request.infiniteScroll', function( event, path ) {
        Pace.stop();
        Pace.bar.render();
    });
});